
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 480 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m472 334.4-135.9-78.4 135.9-78.4c7.7-4.4 10.3-14.2 5.9-21.9l-32-55.4c-4.4-7.7-14.2-10.3-21.9-5.9l-135.9 78.4v-156.8c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v156.9l-136.1-78.5c-7.7-4.4-17.5-1.8-21.9 5.9l-31.9 55.4c-4.4 7.7-1.8 17.4 5.9 21.9l135.8 78.4-135.9 78.4c-7.7 4.4-10.3 14.2-5.9 21.9l32 55.4c4.4 7.7 14.2 10.3 21.9 5.9l135.9-78.4v156.8c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-156.9l135.9 78.4c7.7 4.4 17.5 1.8 21.9-5.9l32-55.4c4.4-7.7 1.8-17.4-5.9-21.9z"}})])
          )
        }
      }
    